import axiosInstance from "../utils/AxiosInstance";
import { getAuthToken } from "../utils/commonHelper";

const API_URL = `${process.env.REACT_APP_API_URL}`;

const customHeaders = {
  'Content-Type': 'application/json',
  'Authorization': `Bearer ${getAuthToken()}`
};

export const fetchLocalizationTableQuery = async (page: number, limit: number, lan: string) => {
  const response = await axiosInstance.get(`${API_URL}/${lan}/localization/table?page=${page}&limit=${limit}`, {
    headers: customHeaders
  });
  return response.data;
};

export const fetchLocalizationQuery = async () => {
  const response = await axiosInstance.get(`${API_URL}/localization`, {
    headers: customHeaders
  });
  return response.data;
};

export const fetchLocalizationByIdQuery = async (id: string, lan: string) => {
  const response = await axiosInstance.get(`${API_URL}/${lan}/localization/${id}`, {
    headers: customHeaders
  });
  return response.data;
};

export const addLocalizationQuery = async (newLocalization: { key: string; value: string; language: string }) => {
  const response = await axiosInstance.post(`${API_URL}/localization`, newLocalization, {
    headers: customHeaders
  });
  return response.data;
};

export const updateLocalizationQuery = async (
  id: string,
  updatedLocalization: { key?: string; value?: string; language?: string },
  lan: string
) => {
  const response = await axiosInstance.put(`${API_URL}/${lan}/localization/${id}`, updatedLocalization, {
    headers: customHeaders
  });
  return response.data;
};

export const removeLocalizationQuery = async (id: string) => {
  const response = await axiosInstance.delete(`${API_URL}/localization/${id}`, {
    headers: customHeaders
  });
  return response.data;
};
